module.exports = __webpack_public_path__ + "img/AdoptionStore.2373a4e6.svg";